<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<mat-expansion-panel id="type" class="bordered">
   <mat-expansion-panel-header>
      <mat-panel-title id="bookingTypePanelTitle">Booking Type</mat-panel-title>
   </mat-expansion-panel-header>

   <mat-button-toggle-group [value]="shipment.shipType" (change)="setType( $event.value )">
      <ng-container *ngFor="let t of types$ | async">
         <mat-button-toggle [id]="t" [value]="t" [disabled]="disabled_type">
            <mat-icon [id]="t + 'Icon'" [svgIcon]="t" class="type-icon"></mat-icon> {{t | uppercase}}
         </mat-button-toggle>
      </ng-container>
   </mat-button-toggle-group>

   <ng-container *ngIf="shipment.shipType === 'international'">
      <br/><br/>

      <mat-button-toggle-group class="mode" [value]="shipment.mode" (change)="setType( shipment.shipType, $event.value )">
         <ng-container *ngFor="let m of modes$ | async">
            <mat-button-toggle [id]="m" [value]="m" [disabled]="disabled_type">
               <mat-icon [id]="m + 'Icon'" [svgIcon]="m" class="type-icon"></mat-icon> {{m | uppercase}}
            </mat-button-toggle>
         </ng-container>
      </mat-button-toggle-group>

      <br/><br/>

      <section class="movement-type">
         <div class="overline">MOVEMENT TYPE</div>
         <ng-container [formGroup]="shipment.shipmentForm.get('movementType')">
            <mat-form-field>
               <mat-select id="movementFromSelect" formControlName="from" [disabled]="disabled_type">
                  <mat-option [id]="type + 'Option'" *ngFor="let type of movements" [value]="type">{{type | titlecase}}</mat-option>
               </mat-select>
            </mat-form-field>
            <span> TO </span>
            <mat-form-field>
               <mat-select id="movementToSelect" formControlName="to" [disabled]="disabled_type">
                  <mat-option [id]="type + 'Option'" *ngFor="let type of movements" [value]="type">{{type | titlecase}}</mat-option>
               </mat-select>
            </mat-form-field>
         </ng-container>
      </section>
   </ng-container>
</mat-expansion-panel>
